/**
 * AllTimeEntries -- every time entry, with a date range and a client /
 * matter search.
 *
 * BM-H3628 (5 Oct 2026), Vanessa: "All my entries, searchable by date range,
 * client, full list. the current My Time page is a bit full for this". A
 * page of its own so My Time stays a place to record time. It reuses
 * TimeEntryList in `full` mode rather than building a second list, so edit,
 * delete, the Billed / Unbilled labels and the filters behave identically.
 *
 * BM-H3749: a director can also see colleagues' time ("if i choose to, with
 * same columns"). A director gets a picker: My time (the default), any
 * active colleague, or Everyone, with the same columns plus a Fee earner
 * column. Everyone else sees only their own time and no picker. This only
 * decides what is OFFERED: GET /time-entries forces a non-director to their
 * own entries whatever is asked.
 */
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ListChecks } from "lucide-react";
import TimeEntryList from "../components/TimeEntryList";
import { STAFF } from "../config/staffConfig";
import { getUserRole, ROLES } from "../config/roleConfig";
import { currentUserEmail } from "../utils/currentUserEmail";

const ME = "me";
const EVERYONE = "all";

export default function AllTimeEntries() {
  const myEmail = currentUserEmail();
  const isDirector = getUserRole(myEmail) === ROLES.DIRECTOR;
  const colleagues = STAFF.filter((s) => s.is_active && s.email && s.email !== myEmail);
  const [whose, setWhose] = useState(ME);

  const viewingOthers = isDirector && whose !== ME;
  const colleagueEmail = viewingOthers && whose !== EVERYONE ? whose : "";

  return (
    <div className="min-h-screen" style={{ background: "#060e18" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "24px 24px 0" }}>
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "#f9fafb", margin: 0 }} className="flex items-center gap-2">
            <ListChecks className="w-5 h-5 text-teal" />
            All My Time Entries
          </h1>
          {isDirector && (
            <label className="flex items-center gap-2 text-sm text-slate-400">
              Show
              <select
                value={whose}
                onChange={(e) => setWhose(e.target.value)}
                className="rounded-md border border-navy-border bg-navy-card px-2.5 py-1.5 text-sm text-white"
                data-testid="time-entries-whose"
              >
                <option value={ME}>My time</option>
                {colleagues.map((s) => (
                  <option key={s.email} value={s.email}>{s.full_name}</option>
                ))}
                <option value={EVERYONE}>Everyone</option>
              </select>
            </label>
          )}
        </div>
        <Link
          to="/my-time"
          className="inline-flex items-center gap-1 mt-2 text-sm text-teal hover:underline"
          data-testid="all-time-entries-back"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Back to My Time
        </Link>
      </div>

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "24px 24px 80px" }}>
        <section
          className="bg-white/[0.02] border border-white/10 rounded-lg p-5"
          data-testid="all-time-entries-card"
        >
          <TimeEntryList
            key={whose}
            full
            showMatterColumn
            mine={!viewingOthers}
            feeEarnerEmail={colleagueEmail}
            showFeeEarner={viewingOthers}
          />
        </section>
      </div>
    </div>
  );
}
